/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Unscheduled/view.blocks to change it.
import React from 'react'
import Tysiav2CalendarUnscheduledIcon from 'DesignSystem/Svgs/Tysiav2CalendarUnscheduledIcon/index'



/** @type {import('Simple/types.js').View} */
export default function Unscheduled({
  children,
  viewPath = "/DesignSystem/AppointmentBookingStateTextWithIcon/StateIcon/Unscheduled",
  fill2
  
}) {
  return (<React.Fragment
>
<Tysiav2CalendarUnscheduledIcon
  viewPath={`${viewPath}/Tysiav2CalendarUnscheduledIcon`}
 fill2={fill2}
 width={10}
 height={10}
/>
{children}
</React.Fragment>)
}